export default __webpack_public_path__ + "static/media/woman-header2.54def518.png";